import { setHasSeenAllMessages } from '@/common/utils/helpers';

export default {
    setSeenAllMessages(state, hasSeen) {
        state.hasSeenAllMessages = hasSeen;
        setHasSeenAllMessages(hasSeen);
    }
};
